import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType, FileType } from "@/common/types/common";
import type { EmployeePayloadType } from "@/common/types/employee";

export async function employeeList(
  account_id: string,
  company_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/company/${company_id}/employee/list${queryString}`,
  );
}

export async function employeeShow(account_id: string, employee_id: string) {
  return await clientAxios.get(
    `account/${account_id}/employee/${employee_id}/show`,
  );
}

export async function employeeCreate(
  account_id: string,
  company_id: string,
  payload: EmployeePayloadType,
) {
  return await clientAxios.post(
    `account/${account_id}/company/${company_id}/employee/create`,
    payload,
  );
}

export async function employeeUpdate(
  account_id: string,
  employee_id: string,
  payload: EmployeePayloadType,
) {
  return await clientAxios.put(
    `account/${account_id}/employee/${employee_id}/update`,
    payload,
  );
}

export async function employeePatch(
  account_id: string,
  employee_id: string,
  payload: Partial<EmployeePayloadType>,
) {
  return await clientAxios.patch(
    `account/${account_id}/employee/${employee_id}/patch`,
    {
      payload,
    },
  );
}

export async function employeeDelete(account_id: string, employee_id: string) {
  return await clientAxios.del(
    `account/${account_id}/employee/${employee_id}/delete`,
  );
}

export async function employeModelCSV(account_id: string) {
  return await clientAxios.get(`account/${account_id}/employee/csv/model`);
}

export async function employeUpload(
  account_id: string,
  company_id: string,
  payload: FileType,
) {
  return await clientAxios.post(
    `account/${account_id}/company/${company_id}/employee/upload`,
    payload,
  );
}
